/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-09-09 09:55:48
 * @LastEditors: hayuu
 * @LastEditTime: 2024-09-11 11:26:38
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: null,
    loginShow: true,
    isLogin: false,
    flag: 1,

    angle: 0
  },
  modules: {
    user,
  },
})

export default store
